import React from 'react';
import {Icon, Container} from 'semantic-ui-react';

const Spinner = props => (
  <Container textAlign='center'>
    <Icon loading name='spinner' size='huge' />
  </Container>
);

export default Spinner;



// WEBPACK FOOTER //
// ./public/pages/UGCModeration/Spinner.jsx